<template>
  <div :class="classes">
    <pt-page-title title="投保信息" :isSearch="true" @search="search" @emptySearch="emptySearch" :keyword="keyword"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <template>
      <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
      <!-- <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button> -->
      <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
      </template>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-insure-info-table ref="table" :paramsData="paramsData">
      <el-table-column slot="before" label="提交时间">
        <template  slot-scope="scope">
            {{scope.row.created_date}}
        </template>
      </el-table-column>
      <el-table-column slot="before" label="样本ID">
        <template  slot-scope="scope">
            <p v-for="(item,index) in scope.row.insurances" :key="index">
              {{item.proBarcode}}
            </p>
        </template>
      </el-table-column>
      <el-table-column slot="before" label="保险产品名称">
        <template  slot-scope="scope">
            <p v-for="(item,index) in scope.row.insurances" :key="index">
              {{item.type}}
            </p>
        </template>
      </el-table-column>
      <el-table-column slot="before" label="存储产品名称">
        <template  slot-scope="scope">
            <p v-for="(item,index) in scope.row.insurances" :key="index">
              {{item.productName}}
            </p>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
            <el-button v-if="hasUpdate" type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
      </el-table-column>
    </pt-insure-info-table>
  </div>
</template>

<script>
import ptInsureInfoTable from './pt-insure-info-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
import { filterLabels } from './insure-info'
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-insure-info'
// 权限
const PERM_INSURE_MATERIAL_MANAGEMENT = 'PERM_INSURE_MATERIAL_MANAGEMENT'
export default {
  name: 'pt-insure-info',
  components: {
    ptInsureInfoTable
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    hasUpdate () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_INSURE_MATERIAL_MANAGEMENT)
    }
  },
  data () {
    return {
      keyword: '',
      params: {},
      paramsData: {},
      filterLabels: filterLabels
    }
  },
  methods: {
    search (val) {
      this.keyword = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'keyword', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'keyword')
    },
    filter () {
      let params = { ...this.params }
      for (var key in params) {
        if (key === 'createDate') {
          params = { ...params, ...params.createDate }
          this.$delete(params, 'createDate')
          this.$delete(params, 'index')
        }
      }
      this.paramsData = { ...params }
      for (var key2 in this.paramsData) {
        if (!this.paramsData[key2]) {
          this.$delete(this.paramsData, key2)
        }
      }
    },
    // 导出
    exportOldToNewAudit () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in params) {
            if (key === 'createDate') {
              params = { ...params, ...params.createDate }
              this.$delete(params, 'createDate')
              this.$delete(params, 'index')
            }
            if (key === 'addressCodes') {
              let addressCode = params.addressCodes.districtGbCode || params.addressCodes.cityGbCode || params.addressCodes.provinceGbCode || ''
              params.addressCode = addressCode
              this.$delete(params, 'addressCodes')
            }
          }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          this.$emit('exportInsureMaterials', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 导出历史
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/insure-material?name=insure_material_export')
    },
    cleanParams () {
      this.params = {}
      emptyObject(this.params)
      this.filter()
    },
    toDetail (val) {
      this.$router.push(`/insure-info-detail/${val.id}`)
    },
    edit (val) {
      this.$router.push(`/insure-info-form/${val.id}`)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
